import request from '@/utils/request'


// 查询用户果实兑换记录列表
export function listFruitExchange(query) {
  return request({
    url: '/user/fruitExchange/list',
    method: 'get',
    params: query
  })
}

// 查询用户果实兑换记录分页
export function pageFruitExchange(query) {
  return request({
    url: '/user/fruitExchange/page',
    method: 'get',
    params: query
  })
}

// 查询用户果实兑换记录详细
export function getFruitExchange(data) {
  return request({
    url: '/user/fruitExchange/detail',
    method: 'get',
    params: data
  })
}

// 新增用户果实兑换记录
export function addFruitExchange(data) {
  return request({
    url: '/user/fruitExchange/add',
    method: 'post',
    data: data
  })
}

// 修改用户果实兑换记录
export function updateFruitExchange(data) {
  return request({
    url: '/user/fruitExchange/edit',
    method: 'post',
    data: data
  })
}

// 删除用户果实兑换记录
export function delFruitExchange(data) {
  return request({
    url: '/user/fruitExchange/delete',
    method: 'post',
    data: data
  })
}
